import React, { useEffect, useState } from "react";
import loginImage01 from "../../../assets/images/registration/registration-steps-image-01.jpg";
import loginImage02 from "../../../assets/images/registration/registration-steps-image-03.jpg";
import loginImage03 from "../../../assets/images/registration/registration-steps-image-04.jpg";
import { languages, raceEthnicities, countries } from "../../../Common/MasterData";
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useTranslation } from 'react-i18next';
import { validateString } from '../../../Common/CommonVariables';
import { ToastContainer, toast } from 'react-toastify'; 
import 'react-toastify/dist/ReactToastify.css';

import { updateUserData } from '../../../Redux/userReducer';
import { Endpoints } from "../../../Global/Endpoints";


const UpdatePhoneNumber = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const token = localStorage.getItem('AccessToken');

  const contract = useSelector((state) => state.userData);
  const dispatch = useDispatch();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    dateOfBirth: "",
    phoneNumber: "",
    agreeToTexts: false,
    country: "",
    zipCode: "",
    language: "",
    raceEthnicity: "",
    preferredName: "",
    gender: "",
    relationshipStatus: "",
    pronouns: "",
    goal: "",
    FirstName: "",

  });

  const [errors, setErrors] = useState({});
  useEffect(() => {
    if (contract.userData) {
      const countryValue =
        countries.find(
          (country) =>
            country.label === contract.userData.Country ||
            country.value === contract.userData.Country
        )?.value || "";
      const languageValue = languages.find(lang => 
        lang.label === contract.userData.Language || lang.value === contract.userData.Language
      )?.value || "";
      const ethnicityValue = raceEthnicities.find(race => 
        race.label === contract.userData.Ethnicity || race.value === contract.userData.Ethnicity
      )?.value || "";

      setFormData({
        FirstName: contract.userData.FirstName || "",
        dateOfBirth: contract.userData.DOB || "",
        phoneNumber: contract.userData.MobileNumber || contract.userData.PhoneNo,
        agreeToTexts: contract.userData.TextNotificationStatus === "Yes",
        country: contract.userData.Country || "",
        zipCode: contract.userData.ZipCode || "",
        language: languageValue,
        raceEthnicity: contract.userData.Country === "Canada" ? "" : ethnicityValue,
        preferredName: contract.userData.PreferredName || "",
        gender: contract.userData.Gender || "",
        relationshipStatus: contract.userData.RelationshipStatus || "",
        pronouns: contract.userData.Pronouns || "",
        goal: contract.userData.Goal || ""
      });
    }
  }, [contract.userData]);
  const handleInputChange = (e) => {
    const { id, value } = e.target;
    if (id === "phoneNumber") {
    // Only allow digits
    const numericValue = value.replace(/\D/g, "");
    setFormData({
      ...formData,
      [id]: numericValue,
    });
  } else {
    const updatedFormData = {
      ...formData,
      [id]: value,
    };

    // Clear ethnicity when Canada is selected
    if (id === "country" && value === "Canada") {
      updatedFormData.raceEthnicity = "";
    }

    setFormData(updatedFormData);
  }
};

  const isValidForm = () => {
    let formErrors = {};
    if (!formData.phoneNumber.trim()) formErrors.phoneNumber = t('phonenumberrequired');
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return; // Prevent double submit
    setIsSubmitting(true);
    if (isValidForm()) {
      debugger
      const updatedData = {
        Company:contract.userData.Company || "",
            Country: contract.userData.Country,
            MemberID: contract.userData.MemberID,
            WhyHere: contract.userData.WhyHere,
            EmailID: contract.userData.EmailID,
            Language: contract.userData.Language,
            Version: "10.8",
            WINBenefits: "Y",
            WINChat : contract?.userData?.WINChat,
            LastName: contract.userData.LastName,
            ZipCode: contract.userData.ZipCode,
            Promocode:  contract.userData.EmployerCode,
            Pronouns: contract.userData.Pronouns,
            UpdateFlag: "Y" ,
            PWD: contract.userData.PWD || "",
            JourneyStatus: contract.userData.JourneyStatus,
            HealthPlanId: contract.userData.HealthPlanId || "",
            PreferredName: contract.userData.PreferredName,
            RelationshipStatus: contract.userData.RelationshipStatus,
            IsHealthProfileCompleted: 1,
            BenefitProvider: contract.userData.BenefitProvider,
            SubscriberID: contract.userData.SubscriberID || "",
            Gender: contract.userData.Gender,
            Contract: contract.userData.ContractIdentified || contract.userData.Contract,
            DOB: contract.userData.DOB,
            AppLanguage: contract.userData.AppLanguage,
            DeviceType:"IOS",
            PhoneNo: formData.phoneNumber,
            //Ethnicity: contract.userData.Ethnicity,
            Ethnicity: contract.userData.Country === "Canada" ? "" : formData.raceEthnicity,
            SecureCode: contract.userData.SecureCode,
            Goal: contract.userData.Goal,
            CountryCode: contract.userData.CountryCode,
            TextNotificationStatus: contract.userData.TextNotificationStatus,
            FirstName: contract.userData.FirstName,
            DeviceType:"PatientPortal",
            PhoneNumber: formData.phoneNumber,
            ContractIdentified: contract.userData.ContractIdentified || contract.userData.Contract,
            MobileNumber: formData.phoneNumber,

            // 🔹 Missing fields added
  TokenID: contract.userData.TokenID || null,
  PortalTokenID: contract.userData.PortalTokenID || null,
  AppUserId: contract.userData.AppUserId || null,
  WINChatToken: contract.userData.WINChatToken || "",

  Enrolled: contract.userData.Enrolled || "No",
  IsRxContract: contract.userData.IsRxContract || "No",
  RxEnrolled: contract.userData.RxEnrolled || "N",
  AppRegistered: contract.userData.AppRegistered || "No",
  UpdateApp: contract.userData.UpdateApp || "No",
  NewApp: contract.userData.NewApp || "No",
  IsManager: contract.userData.IsManager || "N",
  IsInactive: contract.userData.IsInactive || "No",
  PremierRX: contract.userData.PremierRX || "No",
  Reimbursement: contract.userData.Reimbursement || "No",
  Premiere: contract.userData.Premiere || "No",
  NetworkProvider: contract.userData.NetworkProvider || "No",
  DadiProgram: contract.userData.DadiProgram || "No",
  BehavioralConsult: contract.userData.BehavioralConsult || "N",
  SurrogacyAdoption: contract.userData.SurrogacyAdoption || "N",
  WINCard: contract.userData.WINCard || "No",
  PatientConsentAgreement: contract.userData.PatientConsentAgreement || "No",
  IsEnable4thTrimister: contract.userData.IsEnable4thTrimister || "N",
  WincardConsentFlag: contract.userData.WincardConsentFlag || "N",
  APPRatingFlag: contract.userData.APPRatingFlag || "No",
  OldAppUser: contract.userData.OldAppUser || null,
  MemberInActiveFlag: contract.userData.MemberInActiveFlag || null,
  IsHealthIDPresent: contract.userData.IsHealthIDPresent || null,

  FertilityEducationLink: contract.userData.FertilityEducationLink || "",
  ProviderSearchLink: contract.userData.ProviderSearchLink || "",
  BenefitsOverview: contract.userData.BenefitsOverview || "",
  DadiLink: contract.userData.DadiLink || "",
  ContactUs: contract.userData.ContactUs || "",
  CignaHealthyBabiesLink: contract.userData.CignaHealthyBabiesLink || "",

  NotificationStatus: contract.userData.NotificationStatus || "No",
  CustCare: contract.userData.CustCare || "",
  WinManagerPhoneNo: contract.userData.WinManagerPhoneNo || null,

  ProfileName: contract.userData.ProfileName || "",
  ProfilePhoto: contract.userData.ProfilePhoto || "",
  Employer: contract.userData.Employer || "",
  
  Message: contract.userData.Message || null,
  Message2: contract.userData.Message2 || null,
  Result: contract.userData.Result || null,
  Link: contract.userData.Link || null,
  Logo: contract.userData.Logo || "",
  WelcomeText: contract.userData.WelcomeText || "",
  
  SecurityQuestion1: contract.userData.SecurityQuestion1 || null,
  SecurityQuestion2: contract.userData.SecurityQuestion2 || null,
  SecurityAnswer1: contract.userData.SecurityAnswer1 || null,
  SecurityAnswer2: contract.userData.SecurityAnswer2 || null,
  
  Contractlist: contract.userData.Contractlist || null,
  NSP: contract.userData.NSP || "No",
  WINforHIM: contract.userData.WINforHIM || null,
  EmployeeID: "",
  EmployeeFirstName: "",
  EmployeeLastName: "",
  RelationshiptoEmployee: ""
      };
console.log("Updated Data Payload:", updatedData); // Debug log to check the payload
      try {
        const response = await axios.post(
          Endpoints.CreateAccount,
          `_Params=${encodeURIComponent(JSON.stringify(updatedData))}`,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
             // "Authorization": `Bearer ${token}`,
            }
          }
        );
        if (response.data.Result === 2) {
          // Dispatch the action to update user data in the Redux store
          debugger
          dispatch(updateUserData(response.data)); 
          toast.success(t('phonenumberupdate'));
                 // Reset header menu state before navigating home
                 window.dispatchEvent(new Event("resetHeaderMenu"));
      
          // Set a delay of 2 seconds before navigating to the home page
          setTimeout(() => {
            navigate("/home");
          }, 2000); // 2000 milliseconds = 2 seconds
        } else {
          toast.error(response.data.Message || t('updatefailed'));
        }
      } catch (error) {
        console.error("API Error:", error);
        toast.error(t('erroroccuredupdatephonenumber'));
        setIsSubmitting(false); // Allow retry on failure
      }
    }
  };

  useEffect(() => {
    const myCarousel = document.querySelector("#carouselExampleSlidesOnly");
    if (myCarousel) {
        new window.bootstrap.Carousel(myCarousel, {
          interval: 5000, // Set interval in milliseconds
        });
      }
  }, []);
const capitalizeFirstLetter = (name) => {
  if (!name) return ''; // If no name is provided, return an empty string
  return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase(); // Capitalize first letter and lowercase the rest
};

// Prepare country options and selected option for RegistrationDropdown
const countryOptions = countries.map((country) => ({
  id: country.value,
  name: country.label,
}));
const selectedCountryOption = countryOptions.find(
  (option) => option.id === formData.country
) || null;

console.log("Form Data:", formData);

  return (
    <>
      <div className="registration-block-main">
        <div className="registration-image-wrapper">
          <div
            id="carouselExampleSlidesOnly"
            className="carousel slide"
            data-bs-ride="carousel"
          >
            <div className="carousel-inner">
              <div className="carousel-item login-carousel-item active" data-bs-interval="5000">
                <img src={loginImage01} alt="" className="registration-image" />
              </div>
              <div className="carousel-item login-carousel-item" data-bs-interval="5000">
                <img src={loginImage02} alt="" className="registration-image" />
              </div>
              <div className="carousel-item login-carousel-item" data-bs-interval="5000">
                <img src={loginImage03} alt="" className="registration-image" />
              </div>
            </div>
          </div>
        </div>

        <div className="registration-form-main">
          <div className="registration-form">
            <h3 className="page-heading-secondary-black">{t('nicetomeetyou')}</h3>
            <div className="page-heading-bold">
   {capitalizeFirstLetter(formData.preferredName || formData.FirstName)}
</div>

            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label htmlFor="dateOfBirth" className="form-label win-form-label mandatory">{t('dateofbirth')}</label>
                <DatePicker
                  selected={formData.dateOfBirth ? new Date(formData.dateOfBirth) : null}
                  disabled
                  className="form-control win-form-control calendar-control mobile-view"
                />
              </div>

              <div className="mb-3">
                <label htmlFor="phoneNumber" className="form-label win-form-label mandatory">{t('phonenumber')}</label>
                <input
                  type="text"
                  className="form-control win-form-control mobile-view"
                  id="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleInputChange}
                />
                {errors.phoneNumber && <div className="form-field-error-message">{errors.phoneNumber}</div>}
              </div>

              <div className="mb-3">
                <label htmlFor="country" className="form-label win-form-label mandatory">{t('selectcouontry')}</label>
                <select
                  id="country"
                  className="win-form-control select-control mobile-view"
                  value={formData.country}
                  disabled
                >
                  <option value="">{t('selectcouontry')}</option>
                  {countries.map((country) => (
                    <option key={country.id} value={country.label}>
                      {country.label}
                    </option>
                  ))}
                </select>
              </div>

              <div className="mb-3">
                <label htmlFor="zipCode" className="form-label win-form-label mandatory">{t('zipcode')}</label>
                <input
                  type="text"
                  className="form-control win-form-control mobile-view"
                  id="zipCode"
                  value={formData.zipCode}
                  disabled
                />
              </div>              <div className="mb-3">
                <label htmlFor="language" className="form-label win-form-label mandatory">{t('language')}</label>
                <select
                  id="language"
                  className="win-form-control select-control mobile-view"
                  value={formData.language}
                  disabled
                >
                  <option value="">{t('selectlanguage')}</option>
                  {languages.map((lang) => (
                    <option key={lang.value} value={lang.value}>
                      {lang.label}
                    </option>
                  ))}
                </select>
              </div>

              {contract.userData.Country !== "Canada" && (
              <div className="mb-3">
                <label htmlFor="raceEthnicity" className="form-label win-form-label mandatory">{t('ethncity')}</label>
                <select
                  id="raceEthnicity"
                  className="win-form-control select-control mobile-view"
                  value={formData.raceEthnicity}
                  onChange={handleInputChange}
                >
                  <option value="">{t('raceethncity')}</option>
                  {raceEthnicities.map((race) => (
                    <option key={race.value} value={race.value}>
                      {race.label}
                    </option>
                  ))}
                </select>
              </div>
              )}

              <div className="mb-3 mt-4">
                <button className="win-btn-primary mobile-view" type="submit"   disabled={isSubmitting}>
                  {t('Submit')}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default UpdatePhoneNumber;
